/**
 * SHER-327: normalize patient search input by trimming leading/trailing whitespace.
 */
export function trimSearchValue(value: unknown): string {
    if (value == null) return '';
    return String(value).trim();
}

export function trimSearchValues(values: Record<string, unknown>): Record<string, string> {
    const trimmed: Record<string, string> = {};
    for (const [key, value] of Object.entries(values)) {
        trimmed[key] = trimSearchValue(value);
    }
    return trimmed;
}
